import React from "react";

const CloseIcon = ({ fontSize = "small", ...props }) => {
  const size = fontSize === "small" ? "16" : fontSize === "large" ? "32" : "24";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      viewBox="0 96 960 960"
      width={size}
      fill="currentColor"
      {...props}
    >
      <path d="M256 896 128 768l224-224L128 320l128-128 224 224 224-224 128 128-224 224 224 224-128 128-224-224-224 224Z" />
    </svg>
  );
};

export default CloseIcon;
